export const NAVIGATION_ACTIONS = {
    logout: 'logout',
}
